export function cx(...args) {
    return args
      .filter((x) => typeof x === "string")
      .join(" ")
      .trim();
  }